// import { combineReducers } from 'redux'

const reducerKey = 'seaTow'

// const reducer = combineReducers({})
const reducer = {}

export { reducer, reducerKey }
